<template>
  <nav class="navbar navbar-dark bg-dark flex-nowrap">
    <div class="d-flex">
      <router-link
        v-slot="{ href, navigate }"
        to="/"
      >
        <a
          class="navbar-brand navbar-nav mr-2"
          :href="href"
          @click="navigate"
        >
          <img
            src="@/assets/BET_logo_symbol.png"
            width="30"
            height="30"
            class="d-inline-block align-top"
          >
        </a>
      </router-link>
      <button
        id="navbar-toggler"
        class="navbar-toggler mr-2 mr-md-4"
        type="button"
        @click="toggleSidebar()"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <form
        v-if="showEventsFilter"
        class="form-inline"
      >
        <div class="input-group mr-2 mr-md-4">
          <div class="input-group-prepend d-md-flex d-none">
            <label
              class="input-group-text"
              for="event-select"
            >Event</label>
          </div>
          <select
            id="event-select"
            v-model="selectedEvent"
            class="custom-select"
            @change="selectEvent"
          >
            <option
              v-for="event in events"
              :key="event.id"
              :value="event.id"
            >
              {{ event.name }}
            </option>
          </select>
        </div>
      </form>
      <form
        v-if="showViewSelection"
        class="form-inline d-none d-sm-flex"
      >
        <div class="input-group mr-2">
          <div class="input-group-prepend">
            <label
              class="input-group-text"
              for="view-select"
            >View</label>
          </div>
          <select
            id="view-select"
            class="custom-select"
            :value="viewSelection"
            @change="changeViewSelection"
          >
            <option value="0">
              Split
            </option>
            <option value="1">
              Cars
            </option>
            <option value="2">
              Bookings
            </option>
            <option value="3">
              2 Rows of Cars
            </option>
          </select>
        </div>
      </form>
    </div>
    <b-dropdown
      class="user-dd white"
      right
    >
      <template
        v-slot:button-content
      >
        <i class="fa fa-user mr-2" />
        <div class="d-none d-md-inline-block">
          Hi {{ currentUser?currentUser.given_name:"" }}
        </div>
      </template>
      <b-dropdown-item @click="accountDetails">
        Account Details
      </b-dropdown-item>
      <b-dropdown-item @click="logout">
        Log Out
      </b-dropdown-item>
    </b-dropdown>
  </nav>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters(['currentUser', 'headerEvents', 'selectedHeaderEvent', 'viewSelection'])
    },
    data() {
      return {
        selectedEvent: '',
        events: [],
        showEventsFilter: false,
        showViewSelection: false,
      }
    },
    watch: {
      selectedHeaderEvent(newValue, oldValue) {
        this.selectedEvent = newValue
      },
      async $route(to, from) {
        await (this.setHeaderSelections(to));
      },
    },
    async created() {
      await this.loadEvents();
      this.selectedEvent = this.selectedHeaderEvent;
      await this.setHeaderSelections(this.$route);
    },
    methods: {
      async setHeaderSelections(route) {
        if (this.routeCheckForEventsFilter(route)) {
          await this.loadEvents();
          this.showEventsFilter = true
        } else {
          this.showEventsFilter = false
        }
        if (this.routeCheckForViewSelection(route)) {
          this.showViewSelection = true;
        } else {
          this.showViewSelection = false;
        }
      },
      changeViewSelection(value) {
        this.$store.commit('CHANGE_VIEW_SELECTION', parseInt(value.target.value));
      },
      routeCheckForEventsFilter(route) {
        return route.name === 'reporting' || route.name === 'home';
      },
      routeCheckForViewSelection(route) {
        return route.name === 'home'
      },
      selectEvent(event) {
        this.$store.commit("SET_SELECTED_HEADER_EVENT", event.target.value)
      },
      toggleSidebar() {
        this.$store.dispatch('toggleSidebar')
      },
      async loadEvents() {
        try {
          let response = await this.$http.get(`events?searches[hidden]=${false}&limit=100`);
          this.events = response.data.items;
          if (!this.selectedHeaderEvent && response.data.items.length > 0) {
            this.$store.commit('SET_SELECTED_HEADER_EVENT', response.data.items[0].id)
          }
        } catch (error) {
          this.handleErrorResponse(error);
        }
      },
      accountDetails() {
        this.$router.push({name: "myaccount"});
      },
      logout() {
        this.$store.dispatch('logout');
        this.$router.push({name: "signin"});
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

.navbar {
  flex-shrink: 0;
  flex-basis: 56px;
}

#event-select {
  @include media-breakpoint-down(sm) {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
  }
}

  a {
    color: white;

    &:hover {
      text-decoration: none;
      color: white;
    }
  }

  .white {
    color: white;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $success;
    border-color: $success;
  }

  /deep/ .btn.dropdown-toggle {

    background-color: transparent;
    border: none;

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
      padding-right: 0px;
    }
  }

</style>
